import { objectKeys } from "app/helpers/objects";
import type { NewsCategoryType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoryType";
import { NEWS_CATEGORIES_BY_TYPE } from "app/pages/sales-intelligence/sub-modules/signals/utils/news/const";
import type { NewsSignalEventDto } from "../../../types/signals";

export const getNewsSignalCategory = (signal: NewsSignalEventDto): NewsCategoryType | undefined => {
    const categoriesKeys = objectKeys(NEWS_CATEGORIES_BY_TYPE);

    return categoriesKeys.find((key) => NEWS_CATEGORIES_BY_TYPE[key].includes(signal.categories[0]));
};
